import {useQuery} from 'react-query';
import {getSubBrandDetails} from './getSubBrandDetails';

const useGetSubBrandDetails = (subBrandGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['get-sub-brand-details', subBrandGuid],
    queryFn: () => getSubBrandDetails(subBrandGuid),
    enabled: Boolean(subBrandGuid),
  });

  return {data, isLoading};
};

export default useGetSubBrandDetails;
